webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    authed: function authed() {
      __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["a" /* auth */].currentUser;
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      places: []
    };
  },

  //ここから追加
  firestore: function firestore() {
    return {
      places: __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection('places')
    };
  }
  //ここまで追加

});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signup',
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    signUp: function signUp() {
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.username, this.password).then(function (user) {
        alert('Create account: ', user.email);
      }).catch(function (error) {
        alert(error.message);
      });
    }
  }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    signIn: function signIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.username, this.password).then(function (user) {
        alert('Success!');
        _this.$router.push('/');
      }, function (err) {
        alert(err.message);
      });
    }
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signout',
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
        console.log('ログアウトしました');
      }).catch(function (error) {
        console.log('\u30ED\u30B0\u30A2\u30A6\u30C8\u6642\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F (' + error + ')');
      });
    });
  }
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NewPlace",
  data: function data() {
    return {
      form: {},
      placeId: null,
      types: [{ value: null, text: "種別を選んでください" }, { value: "food", text: "飲食店" }, { value: "shop", text: "小売店" }, { value: "spot", text: "観光スポット" }, { value: "person", text: "地元の有名人" }]
    };
  },

  mounted: function mounted() {
    if (this.$route.params.placeId) this.placeId = this.$route.params.placeId;
  },
  methods: {
    //ここから追加（上のコンマもわすれない）
    sendItem: function sendItem() {
      var router = this.$router;
      var placeId = this.placeId;
      var collection = __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection("places");
      if (placeId) {
        //this.form.placeIdじゃなかった
        //もしIDがあったら＝登録済みのデータなら、更新モード
        collection.doc(placeId).set(this.form).then(function (docRef) {
          router.push("/place/" + placeId);
        }).catch(function (error) {
          console.error("Error editting document: ", error);
        });
      } else {
        //なければ今までと一緒で新規作成
        collection.add(this.form).then(function (docRef) {
          router.push("/place/" + docRef.id);
        }).catch(function (error) {
          console.error("Error adding document: ", error);
        });
      }
    },
    deleteItem: function deleteItem() {
      var router = this.$router;
      var placeId = this.placeId;
      var collection = __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection("places");
      if (confirm("本当に削除してしまってもよろしいですか？")) {
        collection.doc(placeId).delete();
        router.push("/");
      }
    },
    uploadfile: function uploadfile(e) {
      var file = e.target.files[0];
      var form = this.form;
      var storageRef = __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["c" /* storage */].ref();
      var imgRef = storageRef.child("uploads/" + file.name);
      imgRef.put(file).then(function (snapshot) {
        snapshot.ref.getDownloadURL().then(function (downloadURL) {
          form.imgUrl = downloadURL;
        }, function (error) {
          alert('ダウンロードURLの取得でエラーが発生しました');
        });
      }, function (error) {
        alert('アップロードでエラーが発生しました');
      });
    }
  },
  firestore: function firestore() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection("places").doc(this.$route.params.placeId)
    };
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Place',
  data: function data() {
    return {
      place: {},
      placeId: null
    };
  },

  computed: {
    authed: function authed() {
      __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["a" /* auth */].currentUser;
    }
  },
  methods: {
    renderMap: function renderMap() {
      //renderMap()の中身を書き換える
      if (this.place.latLng) {
        //37.12345, 140.12345
        var arr = this.place.latLng.split(','); // arr => [37.12345, 140.12345]
        var lat = parseFloat(arr[0]); //37.12345,
        var lng = parseFloat(arr[1]); //140.12345
        this.mapOptions = {
          center: new google.maps.LatLng(lat, lng),
          zoom: 16,
          mapTypeId: 'roadmap'
        };
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        var marker = new google.maps.Marker({ position: { lat: lat, lng: lng }, map: this.map });
      }
      // this.mapOptions = {
      //   center: new google.maps.LatLng(37.6284152,140.9897629),
      //   zoom: 17,
      //   mapTypeId: 'roadmap'
      // }
      // this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions)
    }
  },
  // firestore () {
  //   return {
  //     place: db.collection('places').doc(this.$route.params.placeId)
  //   }
  // },
  mounted: function mounted() {
    //mountedの中身を書き換える
    var _this = this;
    this.placeId = this.$route.params.placeId;
    __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection("places").doc(this.$route.params.placeId).get().then(function (snapshot) {
      _this.place = snapshot.data();
      _this.renderMap();
    });
  }
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__ = __webpack_require__(26);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Map',
  data: function data() {
    return {
      places: [],
      map: Object,
      mapOptions: Object
    };
  },

  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__firebase_firebase__["b" /* db */].collection('places').get().then(function (querySnapshot) {
      _this.places = querySnapshot.docs.map(function (doc) {
        var data = doc.data();
        data.id = doc.id;
        return data;
      });
      _this.renderMap();
    });
  },
  methods: {
    renderMap: function renderMap() {
      var _this = this;
      //renderMap()の中身を書き換える
      _this.mapOptions = {
        center: new google.maps.LatLng(37.5638148, 140.9900094),
        zoom: 14,
        mapTypeId: 'roadmap'
      };
      _this.map = new google.maps.Map(document.getElementById("map"), _this.mapOptions);
      _this.places.map(function (v) {
        if (v.latLng) {
          var latLng = v.latLng.split(',');
          var lat = parseFloat(latLng[0]);
          var lng = parseFloat(latLng[1]);
          var marker = new google.maps.Marker({ position: { lat: lat, lng: lng }, map: _this.map });
          var infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
            content: '<div><a href="/#/place/' + v.id + '" >' + v.name + '</a></div>' // 吹き出しに表示する内容
          });
          marker.addListener('click', function () {
            // マーカーをクリックしたとき
            infoWindow.open(_this.map, marker); // 吹き出しの表示
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_vue_fontawesome__ = __webpack_require__(313);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["a" /* fas */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_9__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire__["a" /* firestorePlugin */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  },
  template: '<App/>'
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ff66b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(253);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ff66b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3f0d94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(251);
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc3f0d94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"toggleable":"lg","fixed":"top","type":"light","variant":"light"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":__webpack_require__(252),"height":"30"}})]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',[_c('b-nav-item',{staticClass:"text-center"},[_vm._v("小高の街案内アプリ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/"}},[_vm._v("TOP")]),_vm._v(" "),(_vm.authed)?_c('b-nav-item',{attrs:{"to":"/place/add"}},[_vm._v("場所を追加")]):_vm._e(),_vm._v(" "),(_vm.authed)?_c('b-nav-item',{attrs:{"to":"/signout"}},[_vm._v("サインアウト")]):_c('b-nav-item',{attrs:{"to":"/signin"}},[_vm._v("サインイン")])],1)],1)],1),_vm._v(" "),_c('b-navbar',{staticStyle:{"padding":"0"},attrs:{"fixed":"bottom","type":"light","variant":"light"}},[_c('b-navbar-nav',{staticClass:"h3",staticStyle:{"width":"100%"},attrs:{"fill":"","justified":""}},[_c('b-nav-item',{attrs:{"to":"/about","exact-active-class":"text-info"}},[_c('font-awesome-icon',{attrs:{"icon":"id-card"}}),_c('h6',[_vm._v("About")])],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/","exact-active-class":"text-info"}},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_c('h6',[_vm._v("一覧")])],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/map","exact-active-class":"text-info"}},[_c('font-awesome-icon',{attrs:{"icon":"map"}}),_c('h6',[_vm._v("地図")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/titlelogo.0652b66.png";

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('b-container',{attrs:{"id":"contents"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Signup__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signin__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Signout__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase_firebase__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NewPlace__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Place__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Map__ = __webpack_require__(275);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */]
  }, {
    path: '/map',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Map__["a" /* default */]
  }, { //2.追加
    path: '/place/add',
    name: 'NewPlace',
    component: __WEBPACK_IMPORTED_MODULE_8__components_NewPlace__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Signup__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Signin__["a" /* default */]
  }, {
    path: '/signout',
    name: 'Signout',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Signout__["a" /* default */]
  }, {
    path: '/place/:placeId',
    name: 'Place',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Place__["a" /* default */]
  }, {
    path: '/place/edit/:placeId',
    name: 'EditPlace',
    component: __WEBPACK_IMPORTED_MODULE_8__components_NewPlace__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    __WEBPACK_IMPORTED_MODULE_7__firebase_firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        next();
      } else {
        next({
          path: '/signin',
          query: {
            redirect: to.fullPath
          }
        });
      }
    });
  } else {
    next(); // next() を常に呼び出すようにしてください!
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e10c1a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(258);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e10c1a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e10c1a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._l((_vm.places),function(place){return _c('b-card',{key:place.id,staticClass:"overflow-hidden mb-4",attrs:{"no-body":""}},[_c('router-link',{attrs:{"to":{ name: 'Place' , params: { placeId: place.id}}}},[_c('b-row',[_c('b-col',{attrs:{"sm":"4","lg":"6"}},[_c('b-card-img',{staticClass:"rounded-0",attrs:{"src":place.imgUrl}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8","lg":"6"}},[_c('b-card-body',{attrs:{"title":place.name}},[_c('b-card-text',[_vm._v(_vm._s(place.description))])],1)],1)],1)],1)],1)}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37eba318_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(260);
var normalizeComponent = __webpack_require__(15)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37eba318_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseConfig = {
  apiKey: 'AIzaSyAJWyYbzLFvfTrTYSlOhsMaAhAw7o-p1aE',
  authDomain: 'odaka-app.firebaseapp.com',
  databaseURL: 'https://odaka-app.firebaseio.com',
  projectId: 'odaka-app',
  storageBucket: "odaka-app.appspot.com",
  messagingSenderId: '944048446893',
  appId: '1:944048446893:web:2bbc62a81538d9cf'
};
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(firebaseConfig);

var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();
var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();
var storage = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage();
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a);

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("このアプリについて")]),_vm._v("このアプリは福島県南相馬市小高区の観光に活用していただくマップアプリです。 ※不定期でデータ更新が入る可能性があります。\n  "),_c('br'),_vm._v(" "),_c('li',[_vm._v("小高区の飲食店、宿泊施設を中心に掲載しています。")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://odakasangyogijutsu-h.fcs.ed.jp/"}},[_vm._v("小高産業技術高校ホームページ")])]),_vm._v(" "),_c('p',[_vm._v("制作：福島県立小高産業技術高等学校プログラミング授業生徒一同")]),_vm._v(" "),_c('li',[_vm._v("このアプリで小高の魅力を知っていただけたら、幸いです。")]),_vm._v(" "),_c('p',[_vm._v("Ver.alpha 1.01")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f099e79a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f099e79a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f099e79a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup"},[_c('h2',[_vm._v("Sign up")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.signUp}},[_vm._v("Register")]),_vm._v(" "),_c('p',[_vm._v("Do you have an account?"),_c('router-link',{attrs:{"to":"/signin"}},[_vm._v("sign in now!!")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162fe3fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(266);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-162fe3fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162fe3fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin"},[_c('h2',[_vm._v("Sign in")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.signIn}},[_vm._v("Signin")]),_vm._v(" "),_c('p',[_vm._v("You don't have an account?\n    "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("create account now!!")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signout_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6440a2b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signout_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6440a2b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6440a2b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin"},[_c('h2',[_vm._v("Sign out")]),_vm._v(" "),_c('p',[_vm._v("You don't have an account?\n    "),_c('router-link',{attrs:{"to":"/signin"}},[_vm._v("ログインする")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlace_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9821cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlace_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPlace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9821cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPlace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.placeId)?_c('h2',[_vm._v("場所を追加する")]):_vm._e(),_vm._v(" "),(_vm.placeId)?_c('h2',[_vm._v("場所を編集する")]):_vm._e(),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.sendItem($event)}}},[_c('b-form-group',{attrs:{"id":"input-group-name","label":"場所の名前","label-for":"input-2"}},[_c('b-form-input',{attrs:{"id":"input-name","required":"","placeholder":"場所の名前"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-description","label":"お店の詳細","label-for":"input-description"}},[_c('b-form-textarea',{attrs:{"id":"input-description","placeholder":"お店の詳細","rows":"3","max-rows":"6"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-img-url","label":"画像URL","label-for":"input-img-url"}},[_c('b-form-file',{attrs:{"placeholder":"画像をドロップするかクリックして選択","drop-placeholder":"ここにドロップ"},on:{"change":_vm.uploadfile}}),_vm._v(" "),(_vm.form.imgUrl)?_c('img',{attrs:{"src":_vm.form.imgUrl,"width":"300"}}):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-img-url","label":"営業時間","label-for":"input-img-url"}},[_c('b-form-input',{attrs:{"placeholder":"10:00-18:00, 24時間営業"},model:{value:(_vm.form.hour),callback:function ($$v) {_vm.$set(_vm.form, "hour", $$v)},expression:"form.hour"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-img-url","label":"種別","label-for":"input-img-url"}},[_c('b-form-select',{attrs:{"options":_vm.types},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"input-group-img-url","label":"地図上の場所","label-for":"input-img-url"}},[_c('b-form-input',{attrs:{"placeholder":"37.6283132,140.989484"},model:{value:(_vm.form.latLng),callback:function ($$v) {_vm.$set(_vm.form, "latLng", $$v)},expression:"form.latLng"}})],1),_vm._v(" "),(!_vm.placeId)?_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("追加する")]):_vm._e(),_vm._v(" "),(_vm.placeId)?_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("編集する")]):_vm._e(),_vm._v(" "),(_vm.placeId)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.deleteItem}},[_vm._v("削除する")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a8fc3d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a8fc3d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a8fc3d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-card',{staticClass:"overflow-hidden",attrs:{"no-body":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('b-card-img',{staticClass:"rounded-0",attrs:{"src":_vm.place.imgUrl}})],1)],1),_vm._v(" "),_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('b-card-body',{attrs:{"title":_vm.place.name}},[_c('b-card-text',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.place.description))]),_vm._v(" "),_c('b-card-text',[_vm._v("営業時間："+_vm._s(_vm.place.hour))]),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),(_vm.authed)?_c('router-link',{attrs:{"to":{ name: 'EditPlace' , params: { placeId: _vm.placeId}}}},[_c('font-awesome-icon',{attrs:{"icon":"cog"}})],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-button',{attrs:{"block":"","variant":"outline-secondary","to":"/"}},[_vm._v("TOPに戻る")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212fa220_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-212fa220"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212fa220_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(240);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ })

},[235]);


// WEBPACK FOOTER //
// static/js/app.da6079dee39584252d22.js